import { ReactNode } from 'react';
import { Box, styled } from '@mui/material';

interface DarkPageTableContainerProps {
  children: ReactNode;
  /** Controls vertical overflow of the table section. Use 'hidden' when the
   * table content manages its own vertical scroll (e.g. react-window). */
  tableOverflowY?: 'auto' | 'hidden';
  toolbar?: ReactNode;
}

export const DarkPageTableContainer = ({
  children,
  tableOverflowY = 'auto',
  toolbar,
}: DarkPageTableContainerProps) => {
  return (
    <Container>
      {toolbar && <ToolbarSection>{toolbar}</ToolbarSection>}
      <TableSection $tableOverflowY={tableOverflowY}>{children}</TableSection>
    </Container>
  );
};

const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  flex: 1;
  background-color: ${({ theme }) => theme.palette.background.paper};
  border-radius: 32px 32px 0 0;
  box-shadow:
    0px 0px 1px 0px rgba(0, 12, 32, 0.04),
    0px 2px 6px 0px rgba(3, 17, 38, 0.11);
  border: 1px solid ${({ theme }) => theme.palette.colors.grey[200]};
  border-bottom: none;
  overflow: hidden;
`;

const ToolbarSection = styled(Box)`
  padding: 16px 24px;
  flex-shrink: 0;
`;

const TableSection = styled(Box)<{ $tableOverflowY: 'auto' | 'hidden' }>`
  flex: 1;
  overflow-x: auto;
  overflow-y: ${({ $tableOverflowY }) => $tableOverflowY};
  padding: 0 24px 24px;
`;
